<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9265 16.6823C11.55 16.6823 11.4089 16.4235 11.6442 16.0941L13.6206 13.4823H6.20887C5.90299 13.4823 5.73828 13.3176 5.73828 13.0117V10.9882C5.73828 10.6823 5.90299 10.5176 6.20887 10.5176H13.6206L11.6442 7.90586C11.4089 7.57645 11.55 7.31763 11.95 7.31763H14.4677C14.7265 7.31763 14.8912 7.41174 15.0324 7.59998L18.1383 11.6706C18.303 11.8823 18.303 12.0941 18.1383 12.3294L15.0324 16.4C14.8912 16.6117 14.7265 16.6823 14.4677 16.6823H11.9265Z"
    />
  </svg>
</template>
